import { useCallback, useMemo, useState } from 'preact/hooks';

import { TFunction, useTranslation } from '../../../utils/useTranslation';
import ns from '../translations';

import { usePlayer } from './PlayerProvider';
import { useJWPlayerEvent } from './useJWPlayerEvent';

const createCaptionList = (
  captions: jwplayer.Caption[] | undefined,
  t: TFunction
) => {
  return (captions ?? []).map((caption, index) => {
    return {
      label: t(caption.label),
      value: index,
    };
  });
};

export const useCaptions = () => {
  const { t } = useTranslation(ns);
  const player = usePlayer();

  const [availableCaptions, setAvailableCaptions] = useState(
    player.getJWPlayer()?.getCaptionsList()
  );
  const [selectedCaptions, setSelectedCaptions] = useState(
    player.getJWPlayer()?.getCurrentCaptions()
  );

  const captionsList = useMemo(
    () => createCaptionList(availableCaptions, t),
    [availableCaptions, t]
  );

  const selectCaptions = useCallback(
    (value: number) => {
      const jw = player.getJWPlayer();
      if (jw) {
        jw.setCurrentCaptions(value);
      }
    },
    [player]
  );

  const handleCaptionsList = useCallback(
    (param: jwplayer.CaptionsListParam) => {
      setAvailableCaptions(param.tracks);
    },
    []
  );

  const handleCaptionsChanged = useCallback(
    (param: jwplayer.CaptionsChangedParam) => {
      setSelectedCaptions(param.track);
    },
    []
  );

  useJWPlayerEvent('captionsList', handleCaptionsList);
  useJWPlayerEvent('captionsChanged', handleCaptionsChanged);

  return {
    captionsList,
    selectedCaptions,
    selectCaptions,
  };
};
